import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addEAR,
    editEAR
} from "./actions";

const headers = [{
    "headerName": "Number",
    "field": "Number"
}, {
    "headerName": "Title",
    "field": "Title",
}, {
    "headerName": "Revision",
    "field": "Revision"
}];

/**
 * Build the attachable-table descriptor for the EAR register that matches
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeEARAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military EAR" : "EAR";
    const labelPlural = isMilitary ? "Military EARs" : "EARs";
    const earParentType = parentTypeFor(variant, "EARs");
    const earCollection = collection(variant, "EARs");

    return {
        "label": labelPlural,
        "key": earParentType,
        "location": `${earCollection}/`,
        "actions": [{
            "label": `Add ${labelSingular}`,
            "action": addEAR
        }],
        "rowActions": [{
            "label": `View ${labelSingular}`,
            action({ router, rowItem }) {
                router.push(`/Database/${earParentType}/${rowItem.ID}`)
            }
        }, {
            "label": "Edit EAR",
            action: editEAR
        }],
        headers
    };
};

export const earAttachable = makeEARAttachable(STC_VARIANT);
export const militaryEARAttachable = isMilitaryEnabled() ? makeEARAttachable(MILITARY_VARIANT) : null;

export default earAttachable;
